<script setup lang="ts">
import { useRouter } from 'vue-router/composables';

const router = useRouter();

router.push({ name: 'Home' });
</script>
